var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import MuiTreeItem from '@material-ui/lab/TreeItem';
function handleItemSpacing() {
    var contentEls = document.getElementsByClassName('MuiTreeItem-content');
    for (var idx = 0; idx < contentEls.length; idx += 1) {
        var contentEl = contentEls[idx];
        var currEl = contentEl;
        var count = 0;
        while (currEl.parentElement) {
            var parent_1 = currEl.parentElement;
            if (parent_1.classList.contains('MuiCollapse-wrapper')) {
                count += 1;
            }
            currEl = parent_1;
        }
        contentEl.style.paddingLeft = "calc(0.75rem + " + count + "rem)";
    }
}
/**
 * Kareo wrapped component of the Material-UI TreeItem. The prop API has been limited to props defined in TreeItemProps.
 *
 * Material-UI TreeItem: [Tree Item](https://v4.mui.com/components/tree-view/), [API](https://v4.mui.com/api/tree-item/)
 *
 * @storybook: [TreeView](http://design.kareoprod.ent/?path=/story/design-system_components-data-display-treeview--basic)
 */
var TreeItem = React.forwardRef(function (props, ref) {
    useEffect(function () {
        handleItemSpacing();
    }, []);
    return React.createElement(MuiTreeItem, __assign({}, props, { ref: ref }));
});
TreeItem.displayName = 'KareoTreeView';
export default TreeItem;
